import { addDaysIso, isIsoDate, todayIso, type DateTimeZone } from "./time-zone";

export interface DateRange {
  start: string;
  end: string;
}

export function recentDateRange(
  days = 30,
  timeZone: DateTimeZone = "UTC",
  now = new Date(),
): DateRange {
  const end = todayIso(timeZone, now);
  return {
    start: addDaysIso(end, -(days - 1), timeZone),
    end,
  };
}

export function isValidDateRange(
  range: DateRange,
  timeZone: DateTimeZone = "UTC",
  now = new Date(),
) {
  if (!isIsoDate(range.start) || !isIsoDate(range.end)) return false;
  return range.start <= range.end && range.end <= todayIso(timeZone, now);
}

export type { DateTimeZone } from "./time-zone";
export { addDaysIso, isIsoDate } from "./time-zone";
